
import OrderService from "~/services/order";
import Homework from "~/views/order/products/homework.vue";
import Jbzyk from "~/views/order/products/jbzyk.vue";
import Jiaoben3 from "~/views/order/products/jiaoben3.vue";
import Szhxy from "~/views/order/products/szhxy.vue";
import Xwt from "~/views/order/products/xwt.vue";
import ZjCooperate from "~/views/order/products/zj-cooperate.vue";
import BeiKe from "~/views/order/products/beike.vue";
import XwtCoin from "~/views/order/products/xwt-coin.vue";
import Website from "~/views/order/products/website.vue";
import Paike from "~/views/order/products/paike.vue";
import ProductBasicInfo from "~/views/order/products/productBasicInfo.vue";
import order_head from "~/views/order/partial/order_head.vue";
import Params from "~/config/params";

export const OrderMixin = {
    data(){
        return {
            loading:true,//加载
            goodsType: [],//物品类型
            expressOptions: [],//快递信息列表
            statusOptions: [],//状态信息列表
            check_type: 0,//审核订单类型 1新增2关闭3修订4补充
            activeTab: "2",//tab类型 1产品2财务3合同
            id: this.$route.query["id"],
            params:{},
            orderData: "",
            version: '',
            product: {},
        }
    },
    components: {
        performance,
        Homework,
        Jbzyk,
        Jiaoben3,
        Szhxy,
        Xwt,
        ZjCooperate,
        BeiKe,
        XwtCoin,
        Website,
        Paike,
        order_head,
        ProductBasicInfo
    },
    created(){
        this.params = Params;
        this.check_type = this.$route.query['type']?this.$route.query['type']:2;
        this.activeTab = this.$route.query['flow_type']?this.$route.query['flow_type']:"2";
        this.expressOptions = OrderService.options();
        this.goodsType = OrderService.goodsType();
        this.statusOptions = OrderService.statusOptions();
    },
    methods: {
        toWrite(type){
            if(this.orderData && (this.orderData.business_audit !=1 || this.orderData.revise_product)){
                this.$message({
                    message: '产品信息审核通过后,才允许填写财务/合同',
                    type: 'warning'
                });
                return false;
            }
            this.$router.push({
                path: '/order/edit',query:{id:this.orderData.id,type:type}
            });
        },
        switchTab(tab) {
            this.activeTab = tab.name;
        },
        getOrder(order_id){
            this.loading = false;
            OrderService.getDetail(order_id).then(res => {
                if (res && res.data) {
                    this.orderData = Object.assign({},this.orderData,res.data);
                    if(!this.$route.query['flow_type']){
                        if(this.orderData.finance){
                            this.activeTab = "2";
                        }else if(this.orderData.contracts.length>0){
                            this.activeTab = "3";
                        }
                    }
                    if(this.$route.query['tab']){
                        this.activeTab = this.$route.query['tab']=='finance'?"2":"3";
                    }
                    this.$emit('update:order',this.orderData);
                    this.$emit('update:old-order',this.orderData);
                }
                this.loading = false;
            })
        },
    }
};


// WEBPACK FOOTER //
// ./src/services/OrderMixin.js